export const NumTwoCircleIcon = () => {
    return (
        <svg width="100%" height="100%" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="20" cy="20.5791" r="18.6667" stroke="url(#paint0_linear_971_23868)" strokeWidth="2.66667"/>
            <path
                d="M13.464 30.5791V27.8551L20.76 21.3991C22.116 20.1991 22.656 19.3591 22.656 18.1711C22.656 16.4071 21.348 15.6631 19.704 15.6631C17.856 15.6631 16.656 16.7311 16.296 18.5551L13.2 18.0151C13.932 14.8111 16.308 12.9631 19.68 12.9631C23.016 12.9631 25.74 14.5711 25.68 18.2191C25.644 20.4391 24.288 22.1671 23.172 23.1631L17.868 27.8551H25.692V30.5791H13.464Z"
                fill="url(#paint1_linear_971_23868)"/>
            <defs>
                <linearGradient id="paint0_linear_971_23868" x1="22.7586" y1="-21.7738" x2="77.5901" y2="63.8423"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
                <linearGradient id="paint1_linear_971_23868" x1="20.5345" y1="-11.7444" x2="65.5383" y2="22.2576"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
            </defs>
        </svg>
    );
};